export default __webpack_public_path__ + "static/media/Frame_185.01d73958.jpg";